import React from 'react';

const WhyVisit = (props) => (
  <div className="flex flex-row pb-20" style={{ alignItems: 'center' }}>
    <div
      style={{
        padding: '10px',
        backgroundColor: props.backgroundColor || '#C4C4C4',
        borderRadius: '50%',
        minWidth: '44px',
        height: '40px',
      }}
    >
      <img
        src={props.icon}
        alt=""
        style={{
          width: props.imageWidth || '24px',
          height: props.imageHeight || '21px',
        }}
      />
    </div>
    <div
      style={{
        marginLeft: '20px',
      }}
    >
      <p
        style={{
          color: '#0D2059',
          fontWeight: 600,
          fontSize: '12px',
          lineHeight: '15px',
        }}
      >
        {props.title}
      </p>
      <p
        style={{
          color: '#465C67',
          fontWeight: 500,
          fontSize: '10px',
          lineHeight: '12px',
          paddingTop: '4px',
        }}
      >
        {props.desc}
      </p>
    </div>
  </div>
);

export default WhyVisit;
